define.alias("shared/components/shared/ui/social-profile-switcher/list", "calendar/components/shared/ui/social-profile-switcher/list");